import type { EnumType } from "#public"

export const Render = <N extends string, T = {}, R = string>(
  names: { [K in N]: (ctx: NoInfer<T>) => R },
  item: EnumType<N, T>
): R => names[item.enum](item as T)
